import React, { useEffect, useState } from 'react'
import { useProject } from '../../../context/project'
import { useSection } from '../../../context/section'
import useFinancial from "../../../hooks/useFinancial"
import BarGroupGraph from '../../Graphs/BarGroup/BarGroupGraph'
import { barGroupColors } from '../../../utils/constants'
import { Skeleton, Grid } from '@mui/material'
import Select from '../../ui/SelectWithExternalLabel'
import useDeepCorrelation from '../hooks/useDeepCorrelation'
import Modal from '../../Modal'
import styles from './DeepCorrelationModal.module.scss'

export default function DeepCorrelationModal({ openModal, setOpenModal, selectedDataset, setSelectedDataset}) {
    const [timeFrame, setTimeFrame] = useState('W')
    const [selectedDatasetDict, setSelectedDatasetDict] = useState()
    const { selectedData } = useSection()
    const { financialInfo, dataset } = selectedData
    const { privateCompany } = useProject()
    const { ticker } = useProject()

    const timeValue = [
      {value: 'W', name: 'Weekly', disable: false}, 
      {value: 'M', name: 'Monthly', disable: false}, 
      {value: 'Q', name: 'Quarterly', disable: false} 
    ]
     
    const { options } = useFinancial(ticker)
    const selectedFinancialInfo = options?.find(t => t.value === financialInfo)
    const handleClose = () => setOpenModal(false)
    const handleTimeframeChange = (e) => setTimeFrame(e.value)
    const handleDatasetChange = (e) => setSelectedDataset(dataset.find(item => (`${item.columnValue}_${item.datasetValue}` === e.value)))
    const formatValueToDecimal = (value) => (value <0? `(${-value.toFixed(3)})`: value.toFixed(3))
    const alternativeDataOptions = () => (dataset.map(item => ({value: `${item['columnValue']}_${item['datasetValue']}`, name: item.columnName, disable: false})))

    const { loading, correlationData } = useDeepCorrelation(financialInfo, privateCompany, ticker, openModal, timeFrame, selectedDatasetDict)

    useEffect(()=>{ 
      setSelectedDatasetDict({...selectedDataset, agg: 'mean'})
      return () => {}
    },[selectedDataset])
  
    const selectTimeFrame = () => (
      <div> 
        <Select elevation={1} customClassName={styles['timeframe-select']} options={timeValue} value={timeFrame} setValue={handleTimeframeChange}/> 
      </div>
    )
    
    const selectData = () => {
      const options = alternativeDataOptions()
      const value = `${selectedDataset.columnValue}_${selectedDataset.datasetValue}`
      return (
        <div className={styles['select-div']}>
          <Select label={'Alternative Data'} elevation={1} customClassName={styles['data-select']} options={options} value={value} setValue={handleDatasetChange}/> 
        </div>
      )
    }

    const financeInfo = () => (
      <>
        <label className={styles['label']}>Financial KPI</label>
        <div className={styles['financial-info']}>{selectedFinancialInfo ? (selectedFinancialInfo.name) : null}</div>
      </>
    )
  
    const graphOptions = () => ( 
      <div style={{ marginTop: '10px'}}> 
        <Grid container spacing={2} style={{alignItems: 'center', alignContent: 'flex-end', width: '1200px'}}>
          <Grid item style={{paddingBottom:'20px'}}>{selectData()} </Grid>
          <Grid item><p>Correlated with</p></Grid>
          <Grid item>{financeInfo()}</Grid>
          <Grid item><p>with the alternative data shifted (lead/lag) over</p></Grid>
          <Grid item>{selectTimeFrame()}</Grid>
          <Grid item><p>units</p></Grid>
        </Grid>
      </div>
    )
    const informativeSentence = () => ( 
      <div > 
        <Grid container style={{alignItems: 'center', alignContent: 'flex-end', width: '1200px'}}>
          <Grid item><p>"1" means the alternative data has shifted forward over the chosen period and calculated the correlation again a higher value at that point might mean it is a leading indicator.</p></Grid>
        </Grid>
      </div>
    )

  const barGraph = () => ( 
    <div className={styles['graph-container']}>
      <div className={styles['graph']}>
        {correlationData.length && !loading ?  
        (<BarGroupGraph showValue topValue={100} lowValue={-100} formatValue={formatValueToDecimal} axisButtonProps={{extraClassname: styles['correlationAxis']}} data={correlationData} colors={barGroupColors} keys={['value']} xKey='index' showLegend={false}/>) :
        (<Skeleton className={styles['skeleton']} veriant='rect' width={1215}height={843} />)}
      </div>
    </div>
  )
  
  return (
    <Modal elevation={1} title={'Deep Correlation'} open={openModal} handleClose={handleClose} limitWidth={false}>
      <div className={styles['wrapper']}>
        {graphOptions()}
        {informativeSentence()}
        {barGraph()}
      </div>
    </Modal>
  )
}